"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiExposer = void 0;
const decorators_1 = require("./decorators");
/**
 * Exposes api services on the transport of choice.
 */
class ApiExposer {
    /**
     * @param strategy The expose strategy to use to expose instances.
     */
    // eslint-disable-next-line
    constructor(strategy) {
        this.strategy = strategy;
        /**
         * Exposes an instance of a given api on
         * @param instance Instance of a class which has been decorated to indicate which functions can be exposed.
         * @param instanceOptions Transport strategy specific options to use when exposing.
         */
        this.exposeInstance = async (instance, instanceOptions) => {
            const exposableProps = (0, decorators_1.getExposedProperties)(instance);
            const exposedProps = await Promise.all(exposableProps.map(async ({ key, options }) => {
                const customConsumptionOptions = await this.strategy.exposeFunction(instance[key].bind(instance), {
                    key,
                    options,
                    meta: instanceOptions
                });
                return {
                    key,
                    options: customConsumptionOptions
                };
            }));
            await this.strategy.exposeMeta(instanceOptions, exposedProps);
        };
    }
    ;
}
exports.ApiExposer = ApiExposer;
